/**
 * Returns true only when the environment is touch-first/coarse-pointer.
 *
 * Important: many hybrid Windows devices report touch support even when users
 * primarily interact with mouse/trackpad. For drag/gesture/mobile behavior,
 * we should not treat those devices as touch-only.
 */
const detectTouchDevice = (document: Document): boolean => {
    if (typeof window === 'undefined') return false;

    const navigatorRef = window.navigator;
    const maxTouchPoints = navigatorRef.maxTouchPoints || 0;
    const hasLegacyTouchEvent = 'ontouchstart' in document.documentElement;

    const supportsMatchMedia = typeof window.matchMedia === 'function';
    const matches = (query: string): boolean => (
        supportsMatchMedia
            ? window.matchMedia(query).matches
            : false
    );

    const hasCoarsePointer = matches('(pointer: coarse)') || matches('(any-pointer: coarse)');
    const hasFinePointer = matches('(pointer: fine)') || matches('(any-pointer: fine)');
    const canHover = matches('(hover: hover)') || matches('(any-hover: hover)');

    // Hybrid devices (coarse + fine/hover) should be treated as non-touch-first.
    if (hasFinePointer || canHover) return false;

    if (hasCoarsePointer) return true;
    if (maxTouchPoints > 0) return true;

    return hasLegacyTouchEvent;
};

export default detectTouchDevice;
